import { useMemo } from "react";
import Card, { Bar } from "./Card.jsx";
import Ball from "../Ball.jsx";
import { cascadingCount, cascadingRate, topByCount } from "../../lib/lotto.js";

export default function Cascading({ rows }) {
  const lengthDist = useMemo(() => cascadingCount(rows), [rows]);
  const byNumber = useMemo(() => topByCount(cascadingRate(rows), 8), [rows]);
  const lengthMax = Math.max(...Object.values(lengthDist));
  const numberMax = byNumber[0]?.count ?? 1;

  return (
    <Card title="연속번호 분석" subtitle={`총 ${rows.length} 회차 기준`} span={1}>
      <h4 className="muted">연속 길이별 회차 수</h4>
      {[2, 3, 4, 5, 6].map((n) => (
        <Bar
          key={n}
          value={lengthDist[n] || 0}
          max={lengthMax}
          label={`${n}연속`}
        />
      ))}
      <h4 className="muted" style={{ marginTop: 12 }}>
        연속번호에 자주 포함된 번호 TOP 8
      </h4>
      {byNumber.map((d) => (
        <Bar
          key={d.num}
          value={d.count}
          max={numberMax}
          label={<Ball n={d.num} />}
        />
      ))}
    </Card>
  );
}
